export enum CommissionMetodologyEnum
{
  NegotiatedPrice = "NegotiatedPrice",
  OriginalPrice = "OriginalPrice"
}



// WEBPACK FOOTER //
// ./src/services/interfaces/CommissionMetodologyEnum.ts